import React from "react";

import Select from "react-select";

import AibleStep from "containers/CreateWizard/AibleStep";

import styles from "./style.module.css";

export default class ChooseTimePeriod extends React.PureComponent {
  render() {
    const { id, timePeriod, options, isShow, handleUpdate, netImpactLabel } = this.props;

    const isLocked = options && options["lock"];

    return (
      <div className={styles.body}>
        <AibleStep
          id={id}
          bId="chooseTime"
          message={"What is the time period for which you would like to calculate your " + netImpactLabel + "?"}
          secondaryMessage={
            "This sets the time period that I will use to calculate the " +
            "Net Impact of deploying an AI and the Net Impact of your current state."
          }
          isBreak
        >
          <div style={{ width: "200px" }}>
            {isLocked ? (
              timePeriod
            ) : (
              <Select
                value={{ value: timePeriod, label: timePeriod }}
                options={[
                  { label: "Day", value: "Day" },
                  { label: "Week", value: "Week" },
                  { label: "Month", value: "Month" },
                  { label: "Quarter", value: "Quarter" },
                  { label: "Year", value: "Year" }
                ]}
                onChange={(val) => handleUpdate(val.value)}
                menuPlacement="top"
              />
            )}
          </div>
        </AibleStep>
      </div>
    );
  }
}
